import React, { useCallback, useState } from 'react';
import { FilterHidingContext } from './FilterHidingContext';
export const FilterHidingContextProvider = ({ children, hasFilterBarDefault, }) => {
    const [isVisible, setVisible] = useState(false);
    const [hasFilterBar, setHasFilterBar] = useState(!!hasFilterBarDefault);
    const toggleVisible = useCallback(() => setVisible(!isVisible), [isVisible]);
    const registerFilter = useCallback(() => setHasFilterBar(true), []);
    return (<FilterHidingContext.Provider value={{
        isVisible,
        toggleVisible,
        hasFilterBar,
        registerFilter,
    }}>
      {children}
    </FilterHidingContext.Provider>);
};
